import { useEffect, useRef } from 'react';

export function useWindowEventListener<TEvent extends keyof WindowEventMap>(
    type: TEvent,
    listener: (event: WindowEventMap[TEvent]) => void,
) {
    const listenerRef = useRef(listener);

    useEffect(() => {
        listenerRef.current = listener;
    });

    useEffect(() => {
        const listenerWrapper = (event: WindowEventMap[TEvent]) => {
            listenerRef.current(event);
        };

        window.addEventListener(type, listenerWrapper);

        return () => window.removeEventListener(type, listenerWrapper);
    }, [type]);
}
